import { RWebShare } from "react-web-share";
import ShareIcon from "./ShareIcon";

const WebShareIcon = ({ title, caption, url }) => {
  return (
    <RWebShare
      data={{
        title: title,
        text: caption,
        url: url,
      }}
    >
      <button aria-label="Web Share Button">
        <ShareIcon />
      </button>
    </RWebShare>
  );
};

export default WebShareIcon;
